export enum FreeSearchTypes {
  NORMAL = 'normal',
  ZIPCODE = 'zipCode',
}